import React from 'react'
import { status_aktif } from '../../constants/general'
import Dropzone from 'react-dropzone'
import axios from '../../axios';
import FormDropdown from '../../components/FormDropdown'
import DatePicker from 'react-datepicker'
import { FOTO_WALI_HOST } from '../../constants/siteConfig'
import Alert from 'react-s-alert'

const jekel = [
    { key: "l", value: "Laki-laki" },
    { key: "p", value: "Perempuan" },
]

class FormsWali extends React.Component {

    constructor() {
        super()

        this.state = {
            dataSiswa: []
        }

        this.handleAddSiswa = this.handleAddSiswa.bind(this)
    }

    loadDataSiswa() {

        axios.post("/siswa")
            .then(response => {

                const filteredResponse = response.data.data.filter(item => {
                    return item.wali_id === null || item.wali_id === 0
                })

                return filteredResponse.map(item => ({
                    key : parseInt(item.siswa_id, 10),
                    value : item.user.user_nama + " (" + item.siswa_nis + ")"
                }))
            })
            .then(result => {

                this.setState({
                    dataSiswa: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleAddSiswa() {

        const value = this.siswaSelected.value

        if (value !== "") {

            const textValue = this.siswaSelected.options[this.siswaSelected.selectedIndex].text

            this.props.handleAddSiswaButton(value, textValue)
        }
        else {
            Alert.error("Pilih siswa terlebih dahulu!")
        }

    }

    render() {

        return (
            <div>                
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Nama Lengkap Wali</label>
                    <div className="col-md-10">
                        <input
                            name="wali_nama"
                            type="text"
                            className="form-control"
                            placeholder="Nama Lengkap"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_nama} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">
                        No. HP <br />
                        <small className="text-muted">
                            <table>
                                <tr>
                                    <td style={{ verticalAlign: "top" }}><i className="fa fa-info-circle"></i>{" "}</td>
                                    <td>Digunakan sebagai username dan password default wali</td>
                                </tr>
                            </table>
                        </small>
                    </label>
                    <div className="col-md-10">
                        <input
                            name="wali_nohp"
                            type="number"
                            className="form-control"
                            placeholder="No. Handphone"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_nohp} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Alamat</label>
                    <div className="col-md-10">
                        <textarea
                            name="wali_alamat"
                            className="form-control"
                            placeholder="Alamat Lengkap"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_alamat} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Kota</label>
                    <div className="col-md-10">
                        <input
                            name="wali_kota"
                            type="text"
                            className="form-control"
                            placeholder="Alamat Kota"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_kota} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Provinsi</label>
                    <div className="col-md-10">
                        <input
                            name="wali_provinsi"
                            type="text"
                            className="form-control"
                            placeholder="Alamat Provinsi"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_provinsi} />
                    </div>
                </div>                
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Jenis Kelamin</label>
                    <div className="col-md-10">
                        <FormDropdown
                            name="wali_gender"
                            items={jekel}
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_gender} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Tempat Lahir</label>
                    <div className="col-md-10">
                        <input
                            name="wali_tempat_lahir"
                            type="text"
                            className="form-control"
                            placeholder="Tempat Lahir"
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_tempat_lahir} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Tanggal Lahir</label>
                    <div className="col-md-10">
                        <DatePicker
                            selected={this.props.parentState.wali_tanggal_lahir_moment}
                            onChange={(momentObj) => {
                                this.props.handleChangeDatepicker(momentObj, "wali_tanggal_lahir_moment", "wali_tanggal_lahir")
                            }}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">
                        Username
                    </label>
                    <div className="col-md-10">
                        <input 
                            name="wali_username"
                            type="text"
                            className="form-control" 
                            placeholder="Username untuk login" 
                            onChange={this.props.handleChange} 
                            value={this.props.parentState.wali_username} />                                
                    </div>
                </div> 
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">
                        Password
                    </label>
                    <div className="col-md-10">
                        <input 
                            name="wali_password"
                            type="password"
                            className="form-control" 
                            placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
                            onChange={this.props.handleChange} 
                            value={this.props.parentState.wali_password} />                                
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 form-control-label">Status Aktif</label>
                    <div className="col-md-10">
                        <FormDropdown
                            name="wali_status"
                            items={status_aktif}
                            onChange={this.props.handleChange}
                            value={this.props.parentState.wali_status} />
                    </div>
                </div>                                
                {
                    this.props.mode === "Edit" &&
                    (
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Foto Wali</label>
                            <div className="col-md-10">
                                <img
                                    src={FOTO_WALI_HOST + this.props.parentState.wali_foto_exist}
                                    alt=""
                                    style={{ width: "300px" }} />
                            </div>
                        </div>
                    )
                } 
                <div className="form-group row">
                    <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File foto Wali</label>
                    <div className="col-md-12">
                        <Dropzone
                            onDrop={(e) => this.props.onDrop(e, "wali_foto")}
                            multiple={false}
                            style={{
                                width: "100%",
                                height: "auto",
                                border: "2px dashed #e9e9e9",
                                padding: "20px 30px",
                                color: "#888",
                                cursor: "pointer",
                                textAlign: "center",
                                marginBottom: "15px"
                            }}
                        >
                            Klik atau drop file disini untuk mengupload file
                        </Dropzone>

                        {
                            this.props.parentState.wali_foto !== "" &&
                            <span>
                                {this.props.parentState.wali_foto.name} {" "}
                                <button
                                    title="Hapus"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => this.props.handleDeleteFile("wali_foto")}
                                    type="button"
                                >
                                    <i className="fa fa-remove"></i>
                                </button>
                            </span>
                        }
                    </div>
                </div>
            </div>
        )
    }
};

export default FormsWali;


// WEBPACK FOOTER //
// ./src/views/Users/FormsWali.js